/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

// Collection of insurance identifiers for the insurance selection screen on the nonmember form
const nonMemberInsurance: { [index: string]: string } = {};

export default nonMemberInsurance;
